import script from "./ActionMenuTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActionMenuTab.vue?vue&type=script&setup=true&lang=ts"

import "./ActionMenuTab.vue?vue&type=style&index=0&id=73dd4812&lang=scss"

const __exports__ = script;

export default __exports__